module.exports = __webpack_public_path__ + "img/api.31461bb8.svg";